export const FIRST_SORTABLE_COLUMN_INDEX = 4;
